export const skills = [
    // ================= DEVELOPMENT =================
    {
      id: 1,
      category: 'Development',
      name: 'Frontend Development',
      icons: 'Code2',
      level: 'Expert',
      experience: '3+ years',
      tools: ['React.js', 'Next.js', 'JavaScript', 'TypeScript']
    },
    {
      id: 2,
      category: 'Development',
      name: 'Backend & APIs',
      icons: 'Server',
      level: 'Intermediate',
      experience: '2+ years',
      tools: ['Node.js', 'Firebase', 'REST APIs']
    },
    {
      id: 3,
      category: 'Development',
      name: 'Full-Stack Integration',
      icons: 'Layers',
      level: 'Advanced',
      experience: '2+ years',
      tools: ['Authentication', 'Database Design', 'API Integration']
    },
    {
      id: 4,
      category: 'Development',
      name: 'Performance Optimization',
      icons: 'Zap',
      level: 'Advanced',
      experience: '2+ years',
      tools: ['Lazy Loading', 'Code Splitting', 'Speed Optimization']
    },
  
    // ================= DESIGN =================
    {
      id: 5,
      category: 'Design',
      name: 'UI/UX Design',
      icons: 'LayoutDashboard',
      level: 'Advanced',
      experience: '2+ years',
      tools: ['Figma', 'Wireframing', 'Prototyping']
    },
    {
      id: 6,
      category: 'Design',
      name: 'Design Systems',
      icons: 'PenTool',
      level: 'Advanced',
      experience: '2+ years',
      tools: ['Component Systems', 'Typography', 'Color Systems']
    },
    {
      id: 7,
      category: 'Design',
      name: 'Responsive Design',
      icons: 'MonitorSmartphone',
      level: 'Expert',
      experience: '3+ years',
      tools: ['Mobile-first Design', 'Cross-browser UI']
    },
    {
      id: 8,
      category: 'Design',
      name: 'Conversion-Focused UI',
      icons: 'TrendingUp',
      level: 'Advanced',
      experience: '2+ years',
      tools: ['Landing Pages', 'CTA Optimization', 'UX Psychology']
    },
  
    // ================= BUSINESS & NO-CODE =================
    {
      id: 9,
      category: 'Business',
      name: 'No-Code Development',
      icons: 'Layers',
      level: 'Advanced',
      experience: '2+ years',
      tools: ['Bubble.io', 'Framer', 'Webflow']
    },
    {
      id: 10,
      category: 'Business',
      name: 'E-commerce Development',
      icons: 'ShoppingCart',
      level: 'Advanced',
      experience: '2+ years',
      tools: ['Shopify', 'Store Setup', 'Checkout Optimization']
    },
    {
      id: 11,
      category: 'Business',
      name: 'SEO Optimization',
      icons: 'Search',
      level: 'Intermediate',
      experience: '2+ years',
      tools: ['On-page SEO', 'Technical SEO', 'Keyword Strategy']
    },
    {
      id: 12,
      category: 'Business',
      name: 'Deployment & Workflow',
      icons: 'GitBranch',
      level: 'Advanced',
      experience: '3+ years',
      tools: ['Git', 'GitHub', 'Vercel']
    }
  ];